import {
    api,apicommissionConfigList,apicun,apichu,apishe
  } from '@/api/sys/fullamount'
  export default {
    namespaced: true,
    actions: {
        api(context,data){
            console.log(data);
           return api(data).then((res) => {
                  return res;
              }).catch(err => {
                console.log('err: ', err)
              })
        },
        // 通过提成分类类型查找提成配置列表
        apicommissionConfigList(context,data){
          console.log(data);
         return apicommissionConfigList(data).then((res) => {
          console.log(data);
                return res;
            }).catch(err => {
              console.log('err: ', err)
            })
      },
      apicun(context,data){
        console.log(data);
       return apicun(data).then((res) => {
              return res;
          }).catch(err => {
            console.log('err: ', err)
          })
      },
      apichu(context,data){
        console.log(data);
       return apichu(data).then((res) => {
              return res;
          }).catch(err => {
            console.log('err: ', err)
          })
      },
      apishe(context,data){
        console.log(data);
       return apishe(data).then((res) => {
              return res;
          }).catch(err => {
            console.log('err: ', err)
          })
      },
    }
}